import { EllipsisVerticalIcon, HeartIcon, LayoutDashboardIcon } from '@coop/icons';
import { useMemo } from 'react';

import { appConfig } from '../../../../../appConfig';
import { useIsB2BRoute } from '../../../../common/utils/b2bUtils';
import { useHeaderPopoverLinks } from './HeaderProfileDropdown.hooks';
import HeaderProfilePopover from './HeaderProfilePopover';

export const HeaderMyFavoritesDropdown = () => {
    const links = useHeaderPopoverLinks();

    return <HeaderProfilePopover items={links} label="Mina favoriter" icon={<HeartIcon />} />;
};

export const HeaderProfileDotDropdown = () => {
    const isB2BRoute = useIsB2BRoute();

    const links = useHeaderPopoverLinks();

    const items = useMemo(() => {
        const filteredLinks = [...links];

        const overviewPageUrl = isB2BRoute
            ? appConfig.coopSettings.b2b.myCoopOverviewPage?.url
            : appConfig.coopSettings.myCoop.myBonusOverviewPageUrl;

        if (overviewPageUrl) {
            filteredLinks.unshift({
                id: 'myProfile',
                type: 'button',
                name: isB2BRoute ? 'Översikt' : 'Mitt Coop & Bonusöversikt',
                url: overviewPageUrl,
                icon: <LayoutDashboardIcon />,
            });
        }

        return filteredLinks;
    }, [isB2BRoute, links]);

    return (
        <HeaderProfilePopover items={items} label="Min profil" icon={<EllipsisVerticalIcon />} />
    );
};
